module.exports = __webpack_public_path__ + "img/insurance-5.6c3b7f3.svg";